var _rect, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuturAucun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    rx: 25,
    fill: "#F6F6F6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 101.964,
    y1: 48.2207,
    x2: 48.2238,
    y2: 101.961,
    stroke: "#0F0F0F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 101.257,
    y1: 101.963,
    x2: 47.5167,
    y2: 48.2228,
    stroke: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturAucun);
export default __webpack_public_path__ + "static/media/futur_aucun.32b4124b8b6e019c9bab36c37fdfe93d.svg";
export { ForwardRef as ReactComponent };